angular.module('dealerware.web.data').factory('DealerwareTollCollectionx', function ($http, Collection) {

    'use strict';

    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/tolls',

        params                          : undefined,
        responseFormatter               : undefined,
        ignoreDefaultAssociationMapper  : true,
        rootNode                        : 'webhooks',
        rootNodeResponse                : undefined,
        rootNodeRequest                 : undefined,
        requestTransforms               : undefined,
        actionOverrides: undefined,

        model                           : 'TollModel',

        customActions: {
            tolls: {
                method: 'GET',
                endpoint: '/locations/:location_id/tolls',
                rootNode: 'toll_report_items',
                ignoreDefaultAssociationMapper: true
            }
        },

        responseTransforms: {
            index : function(args, data) {
                return data;
            }
        }
    });

    jQuery.extend(collection.prototype, { });

    return collection;
});